import React, {useCallback, useMemo, useRef, useState} from 'react';
import Button from "../../../../components/button/button.jsx";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {FaEraser} from "react-icons/fa";
import {Template} from "../../../../components/template/template.jsx";
import {AgGridReact} from "ag-grid-react";
import {useQuery} from "@tanstack/react-query";
import formBuilderService from "../../../../services/web/form-builder-service.js";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {navigateHook} from "../../../../hooks/use-navigate.js";

const FormBuilderList = () => {
    const navigate = navigateHook();

    const {data} = useQuery({
        queryFn: () => formBuilderService.list(),
        queryKey: ["list"]
    });

    const [columnDefs,] = useState([
        { field: "name", headerName: "Nome", sort: "asc", flex: 1},
        { field: "module", headerName: "Modulo", flex: 2 },
    ])

    const gridRef = useRef(undefined);

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    const theme = useMemo(() => {
        return aggridUtils.generalTheme();
    }, []);

    const handleFilter = useCallback((value) => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            value,
        )
    }, [])

    const onCellClicked = ({data}) => {
        navigate(`/dev/form-builder/form/${data.id}`)
    };

    return (
        <Template>
            <Template.Header>
                <Template.Title>
                    Formulários
                </Template.Title>

                <Button target={"primary"} onClick={() => navigate('/dev/form-builder/form')}>
                    Construtor
                </Button>
            </Template.Header>

            <Template.Body className={"space-y-2"}>
                <Card>
                    <Card.Body>
                        <div className="flex justify-between gap-4">
                            <InputForm
                                id={"name"}
                                classNameWrapper={"w-full"}
                                label={"Nome"}
                                name={"name"}
                                onChange={({target: {value}}) => handleFilter(value)}
                            />

                            <Button>
                                <FaEraser />
                            </Button>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body>
                        <div className={"aggrid-row-pointer h-[calc(100vh-153px)]"}>
                            <AgGridReact
                                ref={gridRef}
                                rowHeight={32}
                                rowData={data ?? []}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus={true}
                                onCellClicked={onCellClicked}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={theme}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default FormBuilderList;